import React, { Fragment } from 'react';

import InfoIcon from 'icons/info.svg';
import PropTypes from 'prop-types';

export default function DivisionAccessDisallowed({
  defaultCompanyName,
  sessionCompanyName,
}) {
  return (
    <>
      <div className='toast__icon'>
        <InfoIcon
          className='inner-icon [&_path]:tw-fill-cyan-600'
          height={20}
          width={20}
        />
      </div>
      <div className='toast__text'>
        <span>
          You are now viewing <strong>{defaultCompanyName}</strong>
        </span>
        {sessionCompanyName ?
          <span>
            {' '}
            because you no longer have access to{' '}
            <strong>{sessionCompanyName}</strong>. Please contact your account
            admin for more information.
          </span>
        : <span>.</span>}
      </div>
    </>
  );
}

DivisionAccessDisallowed.propTypes = {
  defaultCompanyName: PropTypes.string.isRequired,
  sessionCompanyName: PropTypes.string,
};
